(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  class MultiCollectionViewer {
    constructor(container) {
      this.container = container;
      this.tabs = this.container.querySelectorAll('[data-collection-handle]');
      this.contents = this.container.querySelectorAll('[data-collection-content]');
      this.init();
    }

    init() {
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.onTabClick(tab);
        });
      });
    }

    onTabClick(clickedTab) {
      const targetHandle = clickedTab.dataset.collectionHandle;

      this.tabs.forEach((tab) => {
        tab.classList.remove('is-active');
      });
      clickedTab.classList.add('is-active');

      this.contents.forEach((content) => {
        if (content.dataset.collectionContent === targetHandle) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const viewers = document.querySelectorAll('.multi-collection-viewer-tabs');
    viewers.forEach((viewer) => {
      const sectionContainer = viewer.closest('.shopify-section');
      if (sectionContainer) {
        new MultiCollectionViewer(sectionContainer);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
